import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-captain-make-model-permissions',
  templateUrl: './captain-make-model-permissions.component.html',
  styleUrls: ['./captain-make-model-permissions.component.css'],
  providers: [DatePipe]
})
export class CaptainMakeModelPermissionsPopupComponent implements OnInit {
  @Input() permissions: any[] = [];
  @Input() deviceInfo: any; 
  @Input() permissionsModifiedAt: any;
  @Input() isVisible: boolean = true;
  formattedDate: string;

  constructor(private datePipe: DatePipe) {}

  ngOnInit() {
    if (this.permissionsModifiedAt) {
      this.formattedDate = this.datePipe.transform(this.permissionsModifiedAt, 'dd MMMM yyyy');
    }
  }

  closePopup() {
    this.isVisible = false;
  }
}
